import React from 'react';
import './Connect.css';

const Connect = () => {
    return (
        <div className='connect-bg'>
            <div className='container connect-us'>
            <h4>Connect Us</h4>
        </div>
        </div>
    );
};

export default Connect;